import { CustomerAddresses } from "../../Shopify/customer";
import { Modal } from "../../Components/Dialog/Modal";

if (document.querySelector("main.account [data-customer-addresses]")) {
    new CustomerAddresses();

    window.addEventListener("popstate", () => {
        const current = document.querySelector<HTMLFormElement>("main.account form.revealed");
        const next = history.state?.accountForm;
        if (current) {
            document.querySelectorAll("main.account form.revealed").forEach((f) => f.classList.remove("revealed"));
        }
        if (next) {
            document.getElementById(history.state.accountForm).classList.add("revealed");
        }
    });

    const revealBtns = document.querySelectorAll("[data-reveal]") as NodeListOf<HTMLElement>;
    revealBtns.forEach((revealBtn) => {
        const form = document.getElementById(revealBtn.dataset.reveal) as HTMLElement;
        if (form) {
            const cancelBtn = form.querySelector<HTMLButtonElement>('button[data-type="cancel"]');
            revealBtn.addEventListener("click", () => {
                history.pushState({ accountForm: form.id }, "");
                form.classList.add("revealed");
            });
            cancelBtn.addEventListener("click", () => history.back());
        }
    });

    const trashBtns = document.querySelectorAll(".address-item [data-trash]") as NodeListOf<HTMLElement>;
    trashBtns.forEach((trashBtn) => {
        trashBtn.addEventListener("click", async (e) => {
            const currentTarget = e.currentTarget as HTMLAnchorElement;
            e.preventDefault();
            try {
                await new Modal(`address-delete-confirm-${currentTarget.dataset.trash}`).confirm();
                Shopify.postLink(currentTarget.href, {
                    parameters: { _method: "delete" }
                });
            } catch (error) {}
        });
    });
}
